export var CSS_DISABLE_SELECT = "user-select: none;";